import { Component, OnDestroy, OnInit } from '@angular/core';
import { DatePipe, NgClass } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { FeathericonsModule } from '../../icons/feathericons/feathericons.module';
import { RouterLink } from '@angular/router';
import { ToggleService } from './toggle.service';
import { AuthService } from '../../services/auth.service';
import { Subscription } from 'rxjs';
import { UserInfoService } from '../../services/user.service';
import { environment } from '../../environments/environment';


@Component({
    selector: 'app-header',
    standalone: true,
    imports: [FeathericonsModule, MatButtonModule, MatMenuModule, RouterLink, NgClass],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    providers: [
        DatePipe
    ]
})
export class HeaderComponent implements OnInit, OnDestroy {

    initials = '';
    private storageKey = 'userInitials';

    userSubscription?: Subscription;

    constructor(
        public toggleService: ToggleService,
        private authService: AuthService,
        private userService: UserInfoService
    ) {
        this.toggleService.isToggledSideBar$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    ngOnInit(): void {
      this.initUserInitials();
      this.loadUserInitials();
    }

    ngOnDestroy(): void {
      this.userSubscription?.unsubscribe();
    }

    isToggled = false;
    toggleTheme() {
        this.toggleService.toggleTheme();
    }

    toggleSideBar() {
      this.toggleService.toggleSideBar();
    }

    initUserInitials() {
      const stored = sessionStorage.getItem(this.storageKey);
      if (stored !== null) {
        this.initials = stored;
      } else {
        this.initials = '';
      }
    }

    private loadUserInitials() {
      this.userService.userInfo$.subscribe({
        next: response => {
          if (response) {
            this.initials = response["username"].slice(0, 2).toUpperCase();
            this.setInitials(this.initials);
          } else {
            this.initials = '';
          }
        },
        error: error => {
          if (!environment.production) {
            console.log(error);
          }
        }
      });
    }

    logoutClicked() {
      this.authService.setAuthenticate(false);
      this.authService.logout();
    }

    private setInitials(initials: string): void {
      sessionStorage.setItem(this.storageKey, initials);
    }

}
